<template>
  <div class="message_handle">
    <van-form @submit="onSubmit" ref="van_field">

      <van-field
        v-model="message"
        rows="9"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="请输入驳回原因"
        show-word-limit
        
      />
      <div class="foot">
        <button type="submit">提交</button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { mapActions} from 'vuex'
import Vue from 'vue';
import { Notify, Field, Form } from 'vant';
Vue.use(Notify);
Vue.use(Field);
Vue.use(Form);

export default {
  name: "projectHandle",
  components: {},
  props: {
    
  },
  data() {
    return {
      message: ''
    };
  },
  computed: {
    id () {
      return this.$route.query.id
    },
  },
  watch: {},
  methods: {
    ...mapActions('investment', ['setInvestmentTitle','postAttractVerify']),
    onSubmit() {//审核
        if (!this.message) {
          this.$Toast({message: "请输入驳回原因"});
          return
        }
        this.$refs.van_field.validate().then(yes =>{
          this.postAttractVerify({
            id: this.id,
            flag: 2,
            rejectReason: this.message
          }).then(res=>{
            Notify({ type: 'success', message: '操作成功' });
            this.$router.go(-1)
          })
        })
        
    }
  },
  created() {
    this.setInvestmentTitle('驳回原因')
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.message_handle {
    height: 100vh;
    font-family: PingFangSC-Regular;
    padding: 12px 12px 108px;
    background: #FFFFFF;
    /deep/.van-field__error-message {
      display: none;
    }
    /deep/.van-field::after{
      content: none;
    }
    /deep/.van-field{
      background: #F5F5F5;
      border-radius: 3px;
    }
    /deep/.van-field__word-limit{
      color: #CCCCCC;
    }
    .foot{
      position: fixed;
      bottom: 0;
      left: 0;
      bottom: 0;
      padding: 13px 12px 47px;
      background: #FFFFFF;
      width: 100%;
      button{
        border: 0;
        background: #36B374;
        display: block;
        width: 100%;
        padding: 13px;
        line-height: 22px;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 3px;
      }
    }
}
</style>